<template lang='pug'>
  .featured-image.component(v-if='images.length')
    img(v-if='images[0]' :src='images[0].src')
    img(v-else src='no-img.png')
</template>

<script>
  import { db } from '@/main'

  export default {
    name: 'featured-image.component',

    props: {
      collection: { type: String, required: true },
      doc: { type: Object, required: true },
    },

    data() {
      return {
        images: []
      }
    },

    firestore() {
      return {
        images: db.collection( this.collection ).doc( this.doc.id ).collection( 'images' ).orderBy( 'index' )
      }
    }
  }
</script>

<style scoped lang='stylus'>
  .featured-image
    img
      width 150px
      height 150px
      object-fit cover
      @media(max-width: 640px)
        width 75px
        height 75px
</style>
